import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Login from "./Login";
import Home from "./Home";
import SignUp from "./SignUp";
import Allproduct from "./allProducts.js";

import AllproductView from "./allProductsView.js";
import Startup from "./Startup";
import Account from "./Account";
import "../index.css";
import PrivateRoute from "../config/ProtectedRoute";
import AuthRoute from "../config/AuthRoute";
import Error from './Error';

import Admin from "./Admin/index";
import AdminRoute from "../config/AdminRoute";
 
export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" component={Home} exact />
        <AuthRoute path="/login" component={Login} />
        <AuthRoute path="/signup" component={SignUp} />
        <Route path="/allproduct" component={Allproduct} exact />
        <Route path="/allproduct/:id" component={AllproductView} exact />
        <Route path="/startup" component={Startup} />
        <Route path="/investors" component={Startup} />
        <Route path="/grants" component={Startup} />

        <PrivateRoute path="/account" component={Account} />
        <AdminRoute path="/admin" component={Admin} />

        <Route component={Error} />
      </Switch>
    </BrowserRouter>
  );
}